import axios from "axios";
import { normalizeApiError } from "../utils/apiError";


// const url = "http://localhost/facturize-api/apps/hotelaria";
const url = "https://hotelaria.facturize.net";


const api = axios.create({
  baseURL: `${url}/public/index.php`,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(normalizeApiError(error));
  }
);

export { api, url };
